(ns frontend.view.grid.companies-grid.db
  (:require [frontend.db :as app-db]
            [reagent.core :as r]))

(defonce companies (r/cursor app-db/views [:companies-grid]))
(defonce modal-state (r/cursor companies [:modals]))
(defonce grid-entities (r/cursor companies [:grid-entities]))
(defonce sorted-grid-entities (r/cursor companies [:sorted-grid-entities]))
(defonce show-quick-filters? (r/cursor companies [:show-quick-filters?]))
(defonce view-settings (r/cursor companies [:view-settings]))
(defonce view-mode (r/cursor view-settings [:view-mode]))
(defonce filters (r/cursor view-settings [:filters]))
(defonce selected-columns (r/cursor view-settings [:selected-columns]))
(defonce column-widths (r/cursor view-settings [:column-widths]))
(defonce ordered-columns (r/cursor view-settings [:ordered-columns]))

;;kanban related definitions
(defonce kanban (r/cursor companies [:kanban]))
(defonce card-settings? (r/cursor kanban [:card-settings?]))
(defonce card-mode (r/cursor kanban [:card-mode]))
(defonce expanded (r/cursor kanban [:expanded]))
(defonce grouped-by (r/cursor view-settings [:grouped-by]))
(defonce card-settings (r/cursor view-settings [:card-settings]))
(defonce lists (r/cursor kanban [:lists]))
(defonce sorted-kanban-entities (r/cursor companies [:sorted-kanban-entities]))

;;precalculated schema (for performance reasons):
(defonce schema (r/cursor companies [:schema]))
